import React, { useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import { API_BASE_URL } from './config';

function LoginForm() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    code: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSendCode = () => {
    fetch(`${API_BASE_URL}/v1/user/verify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: formData.email }),
    })
      .then((res) => {
        // if (!res.ok) throw new Error('認証コードの送信に失敗しました');
        // return res.json();
      })
      .then((data) => {
        // alert('認証コードを送信しました');
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch(`${API_BASE_URL}/v1/user/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.token) {
          localStorage.setItem('token', data.token);
          // alert('ログイン成功');
          window.location.href = '/';
        } else {
          alert('ログインに失敗しました（トークンがありません）');
        }
      })
      .catch((err) => {
        console.error(err.message);
        alert('ログインに失敗しました（通信エラー）');
      });
  };

  const isEmailEmpty = !formData.email.trim();
  const isFormIncomplete = !formData.email || !formData.password || !formData.code;

  return (
    <div className="container">
      <h2 className="mt-5">ログイン</h2>
      <form onSubmit={handleSubmit} className="mt-3">

        <div className="mb-3">
          <label className="form-label">メールアドレス <span className="text-danger">*</span></label>
          <input type="email" name="email" className="form-control" required value={formData.email} onChange={handleChange} />
        </div>

        <div className="mb-3">
          <label className="form-label">パスワード <span className="text-danger">*</span></label>
          <input type="password" name="password" className="form-control" required value={formData.password} onChange={handleChange} />
        </div>

        <div className="mb-3 d-flex align-items-end gap-3">
          <div className="flex-grow-1">
            <label className="form-label">認証コード <span className="text-danger">*</span></label>
            <input type="text" name="code" className="form-control w-100" placeholder="メールに届いたコードを入力" required value={formData.code} onChange={handleChange} />
          </div>
          <div>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={handleSendCode}
              disabled={isEmailEmpty}
            >
              認証コード送信
            </button>
          </div>
        </div>

        <button type="submit" className="btn btn-primary" disabled={isFormIncomplete}>
          ログイン
        </button>
      </form>
    </div>
  );
}

export default LoginForm;
